import {
    Box,
    Button,
    ThemeColorVariable,
    ThemeShadowVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { t } from "i18next";
import React from "react";

const BookingRequestContinueButton = ({
    handleContinue,
    disabled,
    appendText,
}: {
    handleContinue: () => void;
    disabled?: boolean;
    appendText?: string;
}) => {
    return (
        <Box
            bg={ThemeColorVariable.Background}
            position={{ base: "fixed", md: "static" }}
            bottom={{ base: 0, md: "auto" }}
            right={{ base: 0, md: "auto" }}
            left={{ base: 0, md: "auto" }}
            pt={{ base: ThemeSpaceVariable.Medium, md: ThemeSpaceVariable.None }}
            px={{ base: ThemeSpaceVariable.Medium, md: ThemeSpaceVariable.None }}
            pb={{ base: ThemeSpaceVariable.Large, md: ThemeSpaceVariable.None }}
            zIndex={1}
            boxShadow={{ base: ThemeShadowVariable.Footer, md: "none" }}
        >
            <Button
                onClick={handleContinue}
                disabled={disabled}
                size="lg"
                type="submit"
                w="full"
                variant="primary"
            >
                {t("bookingRequest.continue")} {appendText}
            </Button>
        </Box>
    );
};

export default BookingRequestContinueButton;
